import { Http } from '@/lib/http';

export class ManualLoanInsertionService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/app/manual-loan-insertion';
  }

  insertLoan(data) {
    return this.httpClient().post(`${this.endpoint}`, data);
  }
}